import { gql } from '@apollo/client';
import { genericItemFieldsFragment } from './index';

export const bookmarksFragment = gql`
  fragment bookmarksItemFields on Item {
    ...GenericItemFields
    hasInternalLoan
    business {
      ... on Agency {
        id
      }
      ... on Residence {
        id
      }
    }
    preview {
      thumbnail
      f460x345
    }
  }
  ${genericItemFieldsFragment}
`;
